export var NotificationSSEEvent;
(function (NotificationSSEEvent) {
    NotificationSSEEvent["heartBeat"] = "heartBeat";
    NotificationSSEEvent["pullRequest"] = "pullRequest";
})(NotificationSSEEvent || (NotificationSSEEvent = {}));
export var NotificationReadFlag;
(function (NotificationReadFlag) {
    NotificationReadFlag[NotificationReadFlag["UNREAD"] = 0] = "UNREAD";
    NotificationReadFlag[NotificationReadFlag["READ"] = 1] = "READ";
})(NotificationReadFlag || (NotificationReadFlag = {}));
export var NotificationContentType;
(function (NotificationContentType) {
    NotificationContentType[NotificationContentType["TEXT"] = 0] = "TEXT";
    NotificationContentType[NotificationContentType["LINK"] = 1] = "LINK";
    NotificationContentType[NotificationContentType["CONTACT"] = 2] = "CONTACT";
    NotificationContentType[NotificationContentType["SPEC_LINK"] = 4] = "SPEC_LINK";
})(NotificationContentType || (NotificationContentType = {}));
export var NotificationCardCode;
(function (NotificationCardCode) {
    NotificationCardCode["customerUpdate"] = "customer_update";
    NotificationCardCode["globalSubscription"] = "global_subscription";
    NotificationCardCode["companyProductSubscription"] = "company_product_subscription";
    NotificationCardCode["taskCenterSystemTask"] = "task_center_system_task";
    NotificationCardCode["crmCleanInvalidContact"] = "crm_clean_invalid_contact";
    NotificationCardCode["crmCleanUnsubscribeContact"] = "crm_clean_unsubscribe_contact";
    NotificationCardCode["crmLeadsMarkInvalid"] = "crm_leads_mark_invalid";
    NotificationCardCode["mailPlusUnreadReply"] = "mailPlusUnreadReply";
})(NotificationCardCode || (NotificationCardCode = {}));
export var WxBindStatus;
(function (WxBindStatus) {
    WxBindStatus["unbind"] = "UNBIND";
    WxBindStatus["bind"] = "BIND";
})(WxBindStatus || (WxBindStatus = {}));
